var _path;
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';
class IconVideoLine extends Component {
  constructor(...args) {
    super(...args);
    this.ref = null;
    this.handleRef = el => {
      const elementRef = this.props.elementRef;
      this.ref = el;
      if (typeof elementRef === 'function') {
        elementRef(el);
      }
    };
  }
  render() {
    return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
      name: "IconVideo",
      viewBox: "0 0 1920 1920",
      elementRef: this.handleRef
    }), _path || (_path = /*#__PURE__*/React.createElement("path", {
      d: "M1813.333 1557.195c-557.76 126.826-1148.48 126.826-1706.666 0V468.448c557.76-126.827 1148.48-126.933 1706.666 0v1088.747ZM1879.04 374.26c-600.32-143.573-1238.4-143.466-1838.08 0L0 384.075v1257.493l40.96 9.813c300.053 71.787 609.28 108.054 919.04 108.054 309.867 0 619.2-36.267 919.04-108.054l40.96-9.813V384.075l-40.96-9.814ZM853.333 786.987l376.32 225.813-376.32 225.813V786.987Zm-106.666 640 690.346-414.187-690.346-414.187v828.374Z",
      fillRule: "evenodd"
    })));
  }
}
IconVideoLine.glyphName = 'video';
IconVideoLine.variant = 'Line';
IconVideoLine.displayName = 'IconVideoLine';
// eslint-disable-next-line react/forbid-foreign-prop-types
IconVideoLine.propTypes = {
  ...SVGIcon.propTypes
};
IconVideoLine.allowedProps = [...SVGIcon.allowedProps];
export default IconVideoLine;
export { IconVideoLine };